import { defineComponent, onMounted } from 'vue';
import InternalNotesInput from '@/presentation/components/internal-notes/internal-notes-input.vue';
import InternalNotesCode from '@/presentation/pages/internal-notes/internal-notes.code';

export default defineComponent({
	components: {
		InternalNotesInput
	},
	setup: () => {
		const code = new InternalNotesCode();

		onMounted(code.mounted.bind(code));

		return { };
	}
});
